var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{
        center: _vm.isCentered,
        right: _vm.isRightAlign,
        'border-all': _vm.isBorderCard,
        'cursor-pointer': _vm.isCardLink,
        'column-dynamic': true,
    },on:{"click":_vm.goToCardLink}},[(
                _vm.content.heading &&
                _vm.content.heading[_vm.$i18n.locale] &&
                !_vm.headingLink
            )?_c('div',{class:{
            'border-all': !_vm.isBorderCard && _vm.isBorderHeading,
            'border-bottom': _vm.isBorderCard && _vm.isBorderHeading,
            'd-flex': true,
            'align-center': true,
            'justify-center': true,
            'text-center': true,
        },style:(("background-color: " + _vm.headingBackgroundColor + "; color: #0063a6; min-height: " + (_vm.$vuetify.breakpoint.mdAndDown ? '70px' : '90px')))},[(
                _vm.content.heading &&
                _vm.content.heading[_vm.$i18n.locale] &&
                !_vm.headingLink
            )?_c(_vm.headingSize,{tag:"component",class:{ uppercase: _vm.headingUppercase }},[_vm._v(_vm._s(_vm.content.heading[_vm.$i18n.locale]))]):_vm._e(),_vm._v(" "),(_vm.headingLink)?_c('CtaLinks',{attrs:{"links":_vm.headingLink.links,"layout":"Default"}}):_vm._e()],1):_vm._e(),_vm._v(" "),_c('div',{class:{ 'column--img-square': true }},[(_vm.content.sanityImage && !_vm.imageLink)?_c('EmbedSanityImage',{attrs:{"selectedImage":_vm.content.sanityImage && _vm.content.sanityImage.selectedImage,"classes":"mt-0","alt":_vm.content.sanityImage && _vm.content.sanityImage.alt,"width":"250","height":"300"}}):_vm._e(),_vm._v(" "),(_vm.imageLink)?_c('CtaLinks',{attrs:{"links":_vm.imageLink.links,"layout":"Image","content":_vm.content}}):_vm._e()],1),_vm._v(" "),(_vm.content.blurbage && _vm.content.blurbage[_vm.$i18n.locale])?_c('div',[_c('BlockContent',{attrs:{"blocks":_vm.content.blurbage[_vm.$i18n.locale],"serializers":_vm.serializers}})],1):_vm._e(),_vm._v(" "),(_vm.content.ctaLinks && _vm.content.ctaLinks.links)?_c('div',{class:{
            'd-flex': true,
            'align-center': true,
            'justify-center': true,
        }},[_c('CtaLinks',{attrs:{"links":_vm.content.ctaLinks.links}})],1):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }